import script from "./StatisticsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsDashboard.vue?vue&type=style&index=0&id=4b0b0d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0b0d94"]])

export default __exports__